export default function CreateQrUrl(sub) {
  const isProd = process.env.PUBLIC_URL === "https://amb.nosh.jp";
  const url = "https://inv.nosh.jp";
  // const url = isProd ? "https://inv.nosh.jp" : "https://stg-inv.nosh.jp";
  const accountUrl = `${url}?ambassador_code=${sub}`;
  return accountUrl;
}
